"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = FileCode;

var _FileCode = require("@adobe/react-spectrum-workflow/dist/FileCode");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function FileCode(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_FileCode.A4uFileCode, null));
}